import { render, staticRenderFns } from "./fulledit.vue?vue&type=template&id=a1daf20e"
import script from "./fulledit.vue?vue&type=script&lang=js"
export * from "./fulledit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports